/* eslint-disable no-fallthrough */

import { USER_PERMISSIONS } from "@hyro/dashboard-permissions";
import { FIELD_TYPES } from "@hyro-components/fields/utils";
import LinkToChatIcon from "src/icons/collections/building-blocks/LinkToChatIcon";
import PatientRegistrationIcon from "src/icons/collections/building-blocks/PatientRegistrationIcon";
import CernerIcon from "src/icons/collections/integrations/CernerIcon";
import NiceIcon from "src/icons/collections/integrations/NiceIcon";
import ServiceNowIcon from "src/icons/collections/integrations/ServiceNowIcon";
import ControlledResponseIcon from "src/icons/collections/skills/ControlledResponceIcon";
import FindALocationIcon from "src/icons/collections/skills/FindALocationIcon";
import { capitalize } from "@utils";
import theme from "src/theme";

import CallDetailsRecordIcon from "../../icons/collections/building-blocks/CallDetailsRecordIcon";
import ConversationServiceIcon from "../../icons/collections/building-blocks/ConversationServiceIcon";
import LiveChatIcon from "../../icons/collections/building-blocks/LiveChatIcon";
import PatientIdentification from "../../icons/collections/building-blocks/PatientIdentificationIcon";
import PatientIdentificationPhoneBased from "../../icons/collections/building-blocks/PatientIdentificationPhoneBasedIcon";
import Sip from "../../icons/collections/building-blocks/SipIcon";
import TransferToLiveAgent from "../../icons/collections/building-blocks/TransferToLiveAgentIcon";
import EmptyCircle from "../../icons/collections/EmptyCircle";
import ArteraIcon from "../../icons/collections/integrations/ArteraIcon";
import AWSConnectIcon from "../../icons/collections/integrations/AWSConnectIcon";
import EpicIcon from "../../icons/collections/integrations/EpicIcon";
import GenesysIcon from "../../icons/collections/integrations/GenesysIcon";
import HyroInternalIcon from "../../icons/collections/integrations/HyroInternalIcon";
import SalesforceIcon from "../../icons/collections/integrations/SalesforceIcon";
import SpinSciIcon from "../../icons/collections/integrations/SpinSciIcon";
import TwilioIcon from "../../icons/collections/integrations/TwilioIcon";
import FileBasedIcon from "../../icons/collections/integrations/FileBasedIcon";
import InteractIcon from "../../icons/collections/integrations/InteractIcon";
import DexCareIcon from "../../icons/collections/integrations/DexCareIcon";
import GozioIcon from "../../icons/collections/integrations/GozioIcon";
import SiteCoreIcon from "../../icons/collections/integrations/SiteCoreIcon";
import InsuranceSpotFaqIcon from "../../icons/collections/skills/InsuranceSpotFaqIcon";
import ApptCancellationIcon from "../../icons/collections/skills/ApptCancellationIcon";
import ApptConfirmationOutBoundIcon from "../../icons/collections/skills/ApptConfirmationOutBoudIcon";
import ApptReschedulingIcon from "../../icons/collections/skills/ApptReschedulingIcon";
import AppointmentVerification from "../../icons/collections/skills/ApptVerificationIcon";
import CallToText from "../../icons/collections/skills/CallToTextIcon";
import CheckStatusIcon from "../../icons/collections/skills/CheckStatusIcon";
import FindAProviderIcon from "../../icons/collections/skills/FindAProviderIcon";
import FindAProviderViaApiIcon from "../../icons/collections/skills/FindAProviderViaApiIcon";
import OpenSchedulingIcon from "../../icons/collections/skills/OpenSchedulingIcon";
import PlaygroundIcon from "../../icons/collections/skills/PlaygroundIcon";
import Rx from "../../icons/collections/skills/RxIcon";
import SiteInformationIcon from "../../icons/collections/skills/SiteInformationIcon";
import SmartTransferIcon from "../../icons/collections/skills/SmartTransferIcon";
import Spot from "../../icons/collections/skills/SpotIcon";
import SettingsIcon from "../../icons/collections/SettingsIcon";
import EnglishFlagIcon from "../../icons/flags/EnglishFlagIcon";
import SpanishFlagIcon from "../../icons/flags/SpanishFlagIcon";
import LocationBasedScheduling from "src/icons/collections/skills/LocationBasedScheduling";
import KyruusIcon from "src/icons/collections/integrations/KyruusIcon";
import WebEssentialsIcon from "src/icons/collections/essentials/WebEssentialsIcon";
import VoiceEssentialsIcon from "src/icons/collections/essentials/VoiceEssentialsIcon";
import VoiceOutboundEssentialsIcon from "src/icons/collections/essentials/VoiceOutboundEssentialsIcon";
import SmsOutboundEssentialsIcon from "src/icons/collections/essentials/SmsOutboundEssentialsIcon";
import ITVoiceEssentialsIcon from "src/icons/collections/essentials/ITVoiceEssentialsIcon";
import RxInBasketIcon from "src/icons/collections/skills/RxInBasketIcon";
import MammogramScheduling from "src/icons/collections/skills/MammogramScheduling";
import OutboundBBBIcon from "src/icons/collections/skills/OutboundBBBIcon";
import SummaIcon from "src/icons/collections/integrations/SummaIcon";
import AthenaOneIcon from "src/icons/collections/integrations/AthenaOneIcon";
import YextIcon from "src/icons/collections/integrations/YextIcon";
import ApptSchedulingIcon from "src/icons/collections/skills/ApptSchedulingIcon";
import ApptProximitySchedulingIcon from "src/icons/collections/skills/ApptProximitySchedulingIcon";
import ApptProactiveSchedulingIcon from "src/icons/collections/skills/ApptProactiveSchedulingIcon";
import ApptDepartmentSchedulingIcon from "src/icons/collections/skills/ApptDepartmentSchedulingIcon";
import ApptCareTeamSchedulingIcon from "src/icons/collections/skills/ApptCareTeamSchedulingIcon";
import NewEligibilityIcon from "src/icons/collections/building-blocks/NewEligibilityIcon";
import EmployeeIdentificationIcon from "src/icons/collections/building-blocks/EmployeeIdentificationIcon";
import BillingIcon from "src/icons/collections/skills/BillingIcon";
import EllkayIcon from "src/icons/collections/integrations/EllkayIcon";
import MicrosoftAzureDirectoryIcon from "src/icons/collections/integrations/MicrosoftAzureDirectoryIcon";
import StediIcon from "src/icons/collections/integrations/StediIcon";
import PortalManagementIcon from "src/icons/collections/skills/PortalManagementIcon";
import PasswordResetIcon from "src/icons/collections/skills/PasswordResetIcon";
import TicketCreationIcon from "src/icons/collections/skills/TicketCreationIcon";
import CheckTicketStatusIcon from "src/icons/collections/skills/CheckTicketStatusIcon";
import CloseTheLoopIcon from "src/icons/collections/skills/CloseTheLoopIcon";
import ProviderIcon from "src/icons/collections/knowledge-sources/ProviderIcon";
import LocationIcon from "src/icons/collections/knowledge-sources/LocationIcon";
import KnowledgeSourceDefaultIcon from "src/icons/collections/knowledge-sources/KnowledgeSourceDefaultIcon";

export const BUILDING_BLOCKS = "building-blocks";
export const INTEGRATIONS = "integrations";
export const SKILLS = "skills";
export const KNOWLEDGE_SOURCES = "knowledge-studio";
export const COLLECTION_TO_TITLE = {
  [BUILDING_BLOCKS]: "Building Blocks",
  [INTEGRATIONS]: "Integrations",
  [SKILLS]: "Skills",
  [KNOWLEDGE_SOURCES]: "Knowledge Studio"
};
export const COLLECTIONS_NAMES = {
  [BUILDING_BLOCKS]: "building block",
  [INTEGRATIONS]: "integration",
  [SKILLS]: "skill",
  [KNOWLEDGE_SOURCES]: "knowledge source"
};
export const getCollectionTitle = (collectionName) =>
  COLLECTIONS_NAMES[collectionName] || (collectionName || "").replace(/[-_]/g, " ");

export const getAddNewCollectionButtonText = (collectionName) => `Add ${getCollectionTitle(collectionName)}`;

export const COLLECTION_TO_PERMISSIONS = {
  [BUILDING_BLOCKS]: USER_PERMISSIONS.BUILDING_BLOCKS_PAGE.ADD_BUILDING_BLOCK,
  [INTEGRATIONS]: USER_PERMISSIONS.INTEGRATIONS_PAGE.ADD_INTEGRATION,
  [SKILLS]: USER_PERMISSIONS.SKILLS_PAGE.ADD_SKILL,
  [KNOWLEDGE_SOURCES]: USER_PERMISSIONS.KNOWLEDGE_SOURCES_PAGE.ADD_KNOWLEDGE_SOURCE
};

export const getDialogConst = (collectionName) => {
  const collectionTitle = getCollectionTitle(collectionName);
  return {
    FIRST_STEP_TITLE: `Select ${collectionTitle} type`,
    SECOND_STEP_TITLE: `Create new ${collectionTitle}`,
    SUBTITLE: collectionName === SKILLS ? `Name your new ${collectionTitle} instance and give a brief description.` : `Name your new ${collectionTitle} a unique name and provide a brief description.`,
    FIRST_FIELD_LABEL: collectionName === SKILLS ? `${capitalize(collectionTitle)} instance name` : `${capitalize(collectionTitle)} name`,
    FIRST_FIELD_PLACEHOLDER: `Enter ${collectionTitle}`,
    SECOND_FIELD_LABEL: "Description",
    SECOND_FIELD_PLACEHOLDER: `Enter ${collectionTitle} description`,
    DIALOG_ERROR_TITLE: "Error",
    DIALOG_ERROR_BUTTON_TEXT: "Got it",
    DISPLAY_KEY_ERROR: "You already have a building block named '$instanceName.'",
    EMPTY_FIELD_ERROR: "Please provide a value",
    SELECT_PLACEHOLDER: `${capitalize(collectionTitle)}s`
  };
};

export const GENERIC_ERROR_MESSAGES = {
  SAVE: "It seems like there was an error while trying to save your changes. This could be a temporary issue. Please try again later.",
  DOWNLOAD: "It seems like there was an error while trying to download a file. This could be a temporary issue. Please try again later."
};
export const getDialogErrorContent = (operation, collectionTitle = "") => `It seems like there was an error while trying to ${operation} a ${getCollectionTitle(collectionTitle)}. This could be a temporary issue. Please try again later.`;

export const COLLECTION_DIALOG_TYPES = {
  EDIT: "edit",
  DUPLICATE: "duplicate",
  ENABLE: "enable",
  DISABLE: "disable",
  DELETE: "delete",
  DELETE_LAST_COLLECTION: "delete_last_collection",
  DISABLE_LAST_COLLECTION: "disable_last_collection"
};

export const getDialogsConstants = (collectionName, displayName) => {
  const collectionTitle = getCollectionTitle(collectionName);
  return {
    [COLLECTION_DIALOG_TYPES.EDIT]: {
      TITLE: "Edit name and description",
      BUTTON_TEXT: "Done",
      SUBTITLE: "Modify the details below."
    },
    [COLLECTION_DIALOG_TYPES.DUPLICATE]: {
      TITLE: "Duplicate skill",
      BUTTON_TEXT: "Done",
      SUBTITLE: "You are about to duplicate $instanceName",
      TITLE_FIELD_LABEL: "Name your duplicated skill",
      DESC_FIELD_LABEL: "Description"
    },
    [COLLECTION_DIALOG_TYPES.ENABLE]: {
      TITLE: `Confirm ${collectionTitle} enablement`,
      BUTTON_TEXT: "Enable",
      SUBTITLE: `You are about to enable ${displayName} ${collectionTitle}. Are you sure you want to enable it?`
    },
    [COLLECTION_DIALOG_TYPES.DISABLE]: {
      TITLE: `Confirm ${collectionTitle} disablement`,
      BUTTON_TEXT: "Disable",
      SUBTITLE: `You are about to disable ${displayName} ${collectionTitle}. Please confirm that you want to proceed with this action.`,
      WARNING_SUBTITLE: `You are about to disable ${displayName} ${collectionTitle}. Are you sure you want to disable it?`
    },
    [COLLECTION_DIALOG_TYPES.DELETE]: {
      TITLE: `Confirm ${collectionTitle} deletion`,
      BUTTON_TEXT: "Delete",
      SUBTITLE: `You are about to permanently delete ${displayName} ${collectionTitle}. Please confirm that you want to proceed with this deletion.`,
      WARNING_SUBTITLE: `You are about to permanently delete ${displayName} ${collectionTitle}. Are you sure you want to delete it?`
    },
    [COLLECTION_DIALOG_TYPES.DELETE_LAST_COLLECTION]: {
      TITLE: `${collectionTitle.charAt(0).toUpperCase() + collectionTitle.slice(1)} Deletion`,
      BUTTON_TEXT: "Got it",
      SUBTITLE: "A minimum of 1 skill is required in an agent, you cannot remove this skill."
    },
    [COLLECTION_DIALOG_TYPES.DISABLE_LAST_COLLECTION]: {
      TITLE: `${collectionTitle.charAt(0).toUpperCase() + collectionTitle.slice(1)} Disablement`,
      SUBTITLE: "To disable all skills, please contact your support team.",
      BUTTON_TEXT: "Got it"
    }
  };
};

export const collectionNames = {
  SKILL: {
    VOICE_ESSENTIALS: "f538ddd3-e2dd-461e-bb36-b3a4e0ed3475",
    VOICE_OUTBOUND_ESSENTIALS: "d9fbcd13-9d4a-4ebd-b066-0402df4aee96",
    SMS_OUTBOUND_ESSENTIALS: "dafc0716-b604-4523-b07d-244ba0e1d5b2",
    WEB_ESSENTIALS: "800b0742-241f-49cf-bca3-13dfd5bb14a4",
    IT_HELP_DESK: "9c2ee64b-d387-451e-8487-dfc5bf0436cf",
    ITSD_VOICE_ESSENTIALS: "c019d562-96c0-4eb9-bd2e-2e8835005803",
    CHANNEL_SETTINGS: {
      WEB: "chat_channel_settings",
      VOICE: "voice_channel_settings"
    },
    SPOT: {
      WEB: "ccf91839-88d7-49a1-aa6d-31d6fa6ae4e5",
      VOICE: "4f8ac705-9987-4156-a0c7-afa76ee8a83a"
    },
    APPOINTMENT_CANCELLATION: "614196f6-85a7-432d-8951-555a6be5f79b",
    APPOINTMENT_RESCHEDULING: "29634771-5218-42b9-a5d6-21866cf472cf",
    APPOINTMENT_VERIFICATION: "54d056e9-d1d3-4c62-8839-11f4860187c4",
    APPOINTMENT_SCHEDULING: {
      VOICE: "c16819f5-794c-4126-a905-e5a03c76af60",
      WEB: "103e8df8-00ec-4178-8a10-df2ab854e1fb",
      OUTBOUND: "49c6d228-768f-49f3-8c45-38647fb1d027"
    },
    PROCEDURE_SCHEDULING: "c181a9ce-144b-469f-b428-16f2e67f1bc8",
    PROXIMITY_SCHEDULING: "fd887d50-3969-4e2c-8992-933c54d86c9e",
    PROACTIVE_SCHEDULING: "1b348221-6077-47b4-8a5d-ae67f4b797a1",
    CARE_TEAM_SCHEDULING: "910b7d59-6a19-4664-9158-7cc33ea9fc64",
    DEPARTMENT_SCHEDULING: "e0412f8c-7730-4f6f-8a5b-4ac4e176e55c",
    OUTBOUND_APPOINTMENT_CONFIRMATION: "06620b1c-ff3b-4823-a8a8-594e418e1681",
    SMS_OUTBOUND_APPOINTMENT_CONFIRMATION: "5ea24192-4f29-4856-bd2d-692c93748e1b",
    APPOINTMENT_MANAGEMENT: {
      VOICE: "a2b040f8-2d12-4de2-b04d-b4f44c96daa8",
      WEB: "f14ce644-0419-4b67-8506-527b30deb6b0",
      SMS_OUTBOUND: "be6be942-8cfe-4e54-8a83-78a699bd1e08"
    },
    RX: "e860f45b-e45f-41dd-8d86-7c891149281a",
    RX_IN_BASKET: "cc65358d-db2d-441c-8f0f-49c2f14c1079",
    SMART_TRANSFER: "fa7669e5-ee03-4f4f-9a71-95b31378c975",
    CALL_TO_TEXT: "8e23c273-783d-4091-a740-6fb0f83c3285",
    PLAYGROUND: "222c7eae-6524-49db-80b0-378b06b0eb06",
    SITE_INFORMATION: "edd8e124-8666-473b-a432-a403819e0b3c",
    FIND_A_PROVIDER: "b3f1db83-6c0c-4420-a3f2-69f3c14b0661",
    FIND_A_PROVIDER_VIA_API: "c1b97b93-e8e9-4750-955b-a1817b3bc479",
    FIND_A_LOCATION: "e83fad99-5bf8-4788-a8c4-71134de39399",
    CONTROLLED_RESPONSE: "f8415f89-3a55-464e-972e-aa781954c5a0",
    CHECK_STATUS: "2ec78c28-b899-4ca8-999a-047d9ae858d4",
    LOCATION_BASED_SCHEDULING: "484a5af3-e392-4474-9529-921d7233254b",
    LIVE_CHAT: "9166c685-2538-4489-83ed-33ce854fad4b",
    MAMMOGRAM_SCHEDULING: "404cc19e-c1cb-42f9-b865-6e9f29369615",
    OUTBOUND_BBB: "00438037-ac95-4f9b-a4cb-f62e13fa35d9",
    INSURANCE_SPOT_FAQ: "4d943acf-3905-4820-af21-e9b865ac3239",
    SERVICENOW_NEW: "2ac2c425-acd7-4cc6-9435-a3dbbe03e51d",
    BILLING: "098373b6-436d-46b0-8017-d52b2d5b0b10",
    PORTAL_MANAGEMENT: {
      WEB: "b321ec88-643d-44f2-b132-b001606548c7",
      VOICE: "88c8efa4-83b8-458d-8233-3e8357f864a8"
    },
    PASSWORD_RESET: "f7c9b3a2-1e84-4d6f-9b0c-5a2e8d4f7c19",
    TICKET_CREATION: {
      VOICE: "1741dd3c-1c66-4cba-b067-90b384829fd8",
      WEB: "4bf1619b-df2e-449b-961e-2bb7b3c3ca56"
    },
    CHECK_TICKET_STATUS: "3544da3d-ca27-46d8-8fc2-ca23eef4ede2",
    CLOSE_THE_LOOP: "1a0f2281-3210-4fd1-a81b-5353b8f65a1a"
  },
  BUILDING_BLOCK: {
    TRANSFER_TO_LIVE_AGENT: "9cdd288f-d17f-4185-996b-cd26050f6bef",
    PATIENT_IDENTIFICATION: {
      WEB: "53f6f600-a220-4ae0-909c-08003993cd7d",
      VOICE: "dcb24c0f-0942-42eb-862c-c82ae9267fcb"
    },
    PATIENT_IDENTIFICATION_PHONE_BASED: "2009ffa8-f72f-4808-ad31-eac2e29bcd34",
    SIP: "4474ec70-ebcd-48a3-b51c-40c56a6b3029",
    LIVE_CHAT: "87bc1237-d256-4a5d-a70d-a478337ea87d",
    MULTI_QUEUE_LIVE_CHAT: "4b6ace41-3de9-4871-8408-e720c536a612",
    CONVERSATION_SERVICE: "9e531d58-17de-4498-9f3d-58017389eb4f",
    CALL_DETAILS_RECORD: "7952a877-8e38-47b5-938e-9a322f32a9df",
    PATIENT_REGISTRATION: "581be36d-c7c5-4102-b6c4-90cfa34dde58",
    LINK_TO_CHAT: "f4f6f9f2-7b8f-4f9b-8c2c-5c5d7c3f1d7e",
    NEW_ELIGIBILITY: "a3c7f8d2-9b4e-4a1c-8f2d-5e6a7b8c9d0e",
    EMPLOYEE_IDENTIFICATION: {
      WEB: "4ade97c5-1340-4620-9729-cd66831de4a5",
      VOICE: "cd007bea-5297-4b70-bd27-98913e5b8ac8"
    }
  },
  INTEGRATION: {
    EPIC: "0d0149e3-cf16-445e-a5b0-6ceba426b3ad",
    TCH_EPIC: "36bdbb85-ee74-4ccc-9e7f-c535c396f0c2",
    GENESYS: "43dd337c-8bce-4b6e-8766-0fe846bc95f2",
    ARTERA: "3f5cd43d-a4c6-44c8-94e1-ee1e3181e3a0",
    AWS_CONNECT: "6c2a6b44-03d7-4d20-8dd0-ab24620fb984",
    SALESFORCE_LIVE_CHAT: "8572351d-9467-4179-87b1-00caed164eb9",
    IMH_SALESFORCE: "d4691f16-bcf5-475f-9a06-141d42041bb4",
    SALESFORCE: "74a70bff-874f-413c-b97c-b0724f0d74a6",
    TWILIO: "9ce85c24-e79f-45b4-9780-d6a505cc1acf",
    TWILIO_CUSTOM: "310ee60e-02d8-46fe-9cbb-4730fe3c6b73",
    SPIN_SCI: "19830aba-c924-47b0-94e1-99c4ffbd79ef",
    LIVE_CHAT: "a7c40fad-5de5-4f40-9036-31e69863c2d5",
    IDENTITY_INTEGRATION: "2b5b7a11-8492-45fb-a255-fd7ae2c9d93e",
    CONVERSION_INFORMATION: "6f47c1b2-820a-4d14-8106-cea689e063f8",
    EHR_SIMULATION: "63bee665-1ea4-434a-8378-c7e6fb9973a2",
    ITSD_SIMULATION: "712de7e8-bd96-45a0-bbf9-6daea0e70d05",
    NICE: "a34c8b09-9581-4fef-bc09-dd925a20b085",
    CERNER: "27eb16e8-34ad-40a8-a666-2b5527f43e1c", // aka Oracle Health
    SALESFORCE_KNOWLEDGE: "e6057671-c7c6-46af-82e0-b625051df487",
    SERVICENOW_KNOWLEDGE: "28f7049d-235a-4f20-9544-cfd04d31d885",
    SERVICENOW_IT: "6a37bd9d-d013-4bec-b62a-839e32140640",
    FILE_BASED: "2175b292-9a60-40a6-8819-d99f351eadf0",
    KYRUUS: "cdfdce36-37a1-4ab9-a94b-12da55c62ff7",
    BUILD_API_KYRUUS: "f8a3b2c1-d4e5-6f78-9a0b-c1d2e3f4a5b6",
    INTERACT: "96ff6547-2200-421d-a3cc-3026127d4648",
    DEXCARE: "5c3ef3cc-3f53-406f-baf5-563f96c1836d",
    GOZIO: "a1004eed-d1f0-41cf-8064-35514c218aa2",
    SITECORE: "992ec706-57e4-4e28-bfec-80d26d5ad195",
    SUMMA: "79665ad2-e7c9-47be-82f3-fba7f32019bf",
    ATHENA_ONE: "7e3bb267-665a-456c-a85b-3ce5f0c3de29",
    ATHENA_IDX: "7fedeab9-ea76-46a6-8cf9-4a5f8573ac5a",
    YEXT: "ef9898fe-d71a-4c32-a86a-337dc2bf974b",
    SCHEDULING_DATA_INTEGRATION: "01e6f099-a398-4ee4-812c-498eb574a98b",
    ELLKAY: "280438e2-d6cf-4032-91ee-25915151da8f",
    MICROSOFT_AZURE_DIRECTORY: "93311020-12be-4616-8b97-7e546c39ce74",
    STEDI: "2fed472a-6ea6-4b64-8335-4d21c0ecbd34"
  },
  KNOWLEDGE_SOURCES: {
    PROVIDER: "938c4419-fa4e-48cf-9078-92a0c93ade4a",
    LOCATION: "2944a7ab-b9c7-41bb-ba8b-f62610f401e6",
    SITES_KNOWLEDGE: "71ab3a0e-1441-4ad5-aeb7-448cb868c254"
  }
};

export const getCollectionIcon = (collectionKey, collectionName) => {
  switch (collectionKey) {
    /* SKILLS ICONS */
    case collectionNames.SKILL.CHANNEL_SETTINGS.VOICE:

    case collectionNames.SKILL.CHANNEL_SETTINGS.CHAT: {
      return SettingsIcon;
    }

    case collectionNames.SKILL.VOICE_ESSENTIALS: {
      return VoiceEssentialsIcon;
    }

    case collectionNames.SKILL.VOICE_OUTBOUND_ESSENTIALS: {
      return VoiceOutboundEssentialsIcon;
    }

    case collectionNames.SKILL.SMS_OUTBOUND_ESSENTIALS: {
      return SmsOutboundEssentialsIcon;
    }

    case collectionNames.SKILL.ITSD_VOICE_ESSENTIALS: {
      return ITVoiceEssentialsIcon;
    }

    case collectionNames.SKILL.IT_HELP_DESK:
    case collectionNames.SKILL.WEB_ESSENTIALS: {
      return WebEssentialsIcon;
    }
    case collectionNames.SKILL.RX: {
      return Rx;
    }

    case collectionNames.SKILL.RX_IN_BASKET: {
      return RxInBasketIcon;
    }

    case collectionNames.SKILL.CALL_TO_TEXT: {
      return CallToText;
    }

    case collectionNames.SKILL.PLAYGROUND: {
      return PlaygroundIcon;
    }

    case collectionNames.SKILL.APPOINTMENT_VERIFICATION: {
      return AppointmentVerification;
    }

    case collectionNames.SKILL.APPOINTMENT_CANCELLATION: {
      return ApptCancellationIcon;
    }

    case collectionNames.SKILL.APPOINTMENT_MANAGEMENT.WEB:
    case collectionNames.SKILL.APPOINTMENT_MANAGEMENT.VOICE:
    case collectionNames.SKILL.APPOINTMENT_MANAGEMENT.SMS_OUTBOUND:
    case collectionNames.SKILL.APPOINTMENT_RESCHEDULING: {
      return ApptReschedulingIcon;
    }
    case collectionNames.SKILL.APPOINTMENT_SCHEDULING.VOICE:
    case collectionNames.SKILL.APPOINTMENT_SCHEDULING.WEB: {
      return OpenSchedulingIcon;
    }

    case collectionNames.SKILL.PROXIMITY_SCHEDULING: {
      return ApptProximitySchedulingIcon;
    }

    case collectionNames.SKILL.PROACTIVE_SCHEDULING: {
      return ApptProactiveSchedulingIcon;
    }

    case collectionNames.SKILL.DEPARTMENT_SCHEDULING: {
      return ApptDepartmentSchedulingIcon;
    }

    case collectionNames.SKILL.CARE_TEAM_SCHEDULING: {
      return ApptCareTeamSchedulingIcon;
    }

    case collectionNames.SKILL.APPOINTMENT_SCHEDULING.OUTBOUND: {
      return ApptSchedulingIcon;
    }

    case collectionNames.SKILL.OUTBOUND_APPOINTMENT_CONFIRMATION:
    case collectionNames.SKILL.SMS_OUTBOUND_APPOINTMENT_CONFIRMATION: {
      return ApptConfirmationOutBoundIcon;
    }

    case collectionNames.SKILL.CHECK_STATUS: {
      return CheckStatusIcon;
    }

    case collectionNames.SKILL.SPOT.WEB:
    case collectionNames.SKILL.SPOT.VOICE: {
      return Spot;
    }

    case collectionNames.SKILL.SMART_TRANSFER: {
      return SmartTransferIcon;
    }

    case collectionNames.SKILL.SITE_INFORMATION: {
      return SiteInformationIcon;
    }

    case collectionNames.SKILL.FIND_A_PROVIDER: {
      return FindAProviderIcon;
    }

    case collectionNames.SKILL.FIND_A_PROVIDER_VIA_API: {
      return FindAProviderViaApiIcon;
    }

    case collectionNames.SKILL.FIND_A_LOCATION: {
      return FindALocationIcon;
    }

    case collectionNames.SKILL.CONTROLLED_RESPONSE: {
      return ControlledResponseIcon;
    }

    case collectionNames.SKILL.MAMMOGRAM_SCHEDULING: {
      return MammogramScheduling;
    }

    case collectionNames.SKILL.LOCATION_BASED_SCHEDULING: {
      return LocationBasedScheduling;
    }

    case collectionNames.SKILL.INSURANCE_SPOT_FAQ: {
      return InsuranceSpotFaqIcon;
    }

    case collectionNames.SKILL.PROCEDURE_SCHEDULING: {
      return ApptSchedulingIcon;
    }

    case collectionNames.SKILL.OUTBOUND_BBB: {
      return OutboundBBBIcon;
    }

    case collectionNames.SKILL.BILLING: {
      return BillingIcon;
    }

    case collectionNames.SKILL.LIVE_CHAT:

    /* BUILDING BLOCKS ICONS */
    case collectionNames.BUILDING_BLOCK.LIVE_CHAT:
    case collectionNames.BUILDING_BLOCK.MULTI_QUEUE_LIVE_CHAT: {
      return LiveChatIcon;
    }

    case collectionNames.BUILDING_BLOCK.TRANSFER_TO_LIVE_AGENT: {
      return TransferToLiveAgent;
    }

    case collectionNames.BUILDING_BLOCK.SIP: {
      return Sip;
    }

    case collectionNames.BUILDING_BLOCK.CONVERSATION_SERVICE: {
      return ConversationServiceIcon;
    }
    case collectionNames.BUILDING_BLOCK.PATIENT_IDENTIFICATION.WEB:
    case collectionNames.BUILDING_BLOCK.PATIENT_IDENTIFICATION.VOICE:
      return PatientIdentification;

    case collectionNames.BUILDING_BLOCK.PATIENT_IDENTIFICATION_PHONE_BASED:
      return PatientIdentificationPhoneBased;

    case collectionNames.BUILDING_BLOCK.CALL_DETAILS_RECORD: {
      return CallDetailsRecordIcon;
    }

    case collectionNames.BUILDING_BLOCK.PATIENT_REGISTRATION: {
      return PatientRegistrationIcon;
    }

    case collectionNames.BUILDING_BLOCK.LINK_TO_CHAT: {
      return LinkToChatIcon;
    }

    case collectionNames.BUILDING_BLOCK.NEW_ELIGIBILITY: {
      return NewEligibilityIcon;
    }

    case collectionNames.BUILDING_BLOCK.EMPLOYEE_IDENTIFICATION.WEB:
    case collectionNames.BUILDING_BLOCK.EMPLOYEE_IDENTIFICATION.VOICE:
      return EmployeeIdentificationIcon;

    /* INTEGRATIONS ICONS */
    case collectionNames.INTEGRATION.TCH_EPIC:
    case collectionNames.INTEGRATION.EPIC: {
      return EpicIcon;
    }

    case collectionNames.INTEGRATION.ARTERA: {
      return ArteraIcon;
    }

    case collectionNames.INTEGRATION.TWILIO:
    case collectionNames.INTEGRATION.TWILIO_CUSTOM: {
      return TwilioIcon;
    }

    case collectionNames.INTEGRATION.GENESYS: {
      return GenesysIcon;
    }

    case collectionNames.INTEGRATION.SALESFORCE:
    case collectionNames.INTEGRATION.IMH_SALESFORCE:
    case collectionNames.INTEGRATION.SALESFORCE_LIVE_CHAT:
    case collectionNames.INTEGRATION.SALESFORCE_KNOWLEDGE: {
      return SalesforceIcon;
    }

    case collectionNames.INTEGRATION.SPIN_SCI: {
      return SpinSciIcon;
    }

    case collectionNames.INTEGRATION.AWS_CONNECT: {
      return AWSConnectIcon;
    }

    case collectionNames.INTEGRATION.EHR_SIMULATION:
    case collectionNames.INTEGRATION.ITSD_SIMULATION:
    case collectionNames.INTEGRATION.LIVE_CHAT:
    case collectionNames.INTEGRATION.IDENTITY_INTEGRATION:
    case collectionNames.INTEGRATION.CONVERSION_INFORMATION: {
      return HyroInternalIcon;
    }

    case collectionNames.INTEGRATION.NICE: {
      return NiceIcon;
    }

    case collectionNames.INTEGRATION.CERNER: {
      return CernerIcon;
    }
    case collectionNames.INTEGRATION.SERVICENOW_KNOWLEDGE:
    case collectionNames.INTEGRATION.SERVICENOW_IT:
    case collectionNames.SKILL.SERVICENOW_NEW: {
      return ServiceNowIcon;
    }

    case collectionNames.INTEGRATION.FILE_BASED:
    case collectionNames.INTEGRATION.SCHEDULING_DATA_INTEGRATION: {
      return FileBasedIcon;
    }

    case collectionNames.INTEGRATION.INTERACT: {
      return InteractIcon;
    }

    case collectionNames.INTEGRATION.DEXCARE: {
      return DexCareIcon;
    }

    case collectionNames.INTEGRATION.GOZIO: {
      return GozioIcon;
    }

    case collectionNames.INTEGRATION.SITECORE: {
      return SiteCoreIcon;
    }

    case collectionNames.INTEGRATION.SUMMA: {
      return SummaIcon;
    }

    case collectionNames.INTEGRATION.BUILD_API_KYRUUS:
    case collectionNames.INTEGRATION.KYRUUS: {
      return KyruusIcon;
    }

    case collectionNames.INTEGRATION.ATHENA_ONE:
    case collectionNames.INTEGRATION.ATHENA_IDX: {
      return AthenaOneIcon;
    }

    case collectionNames.INTEGRATION.YEXT: {
      return YextIcon;
    }

    case collectionNames.INTEGRATION.ELLKAY: {
      return EllkayIcon;
    }

    case collectionNames.INTEGRATION.MICROSOFT_AZURE_DIRECTORY: {
      return MicrosoftAzureDirectoryIcon;
    }

    case collectionNames.INTEGRATION.STEDI: {
      return StediIcon;
    }

    case collectionNames.SKILL.PORTAL_MANAGEMENT.VOICE:
    case collectionNames.SKILL.PORTAL_MANAGEMENT.WEB: {
      return PortalManagementIcon;
    }

    case collectionNames.SKILL.PASSWORD_RESET: {
      return PasswordResetIcon;
    }

    case collectionNames.SKILL.TICKET_CREATION.VOICE:
    case collectionNames.SKILL.TICKET_CREATION.WEB: {
      return TicketCreationIcon;
    }

    case collectionNames.SKILL.CHECK_TICKET_STATUS: {
      return CheckTicketStatusIcon;
    }

    case collectionNames.SKILL.CLOSE_THE_LOOP: {
      return CloseTheLoopIcon;
    }

    // KNOWLEDGE SOURCE icons
    case collectionNames.KNOWLEDGE_SOURCES.PROVIDER:
      return ProviderIcon;
    case collectionNames.KNOWLEDGE_SOURCES.LOCATION:
    case collectionNames.KNOWLEDGE_SOURCES.SITES_KNOWLEDGE: {
      return LocationIcon;
    }

    default: {
      return collectionName === KNOWLEDGE_SOURCES ? KnowledgeSourceDefaultIcon : EmptyCircle;
    }
  }
};

export const LANGUAGES = {
  ENGLISH: "ENGLISH",
  SPANISH: "SPANISH"
};

export const getLanguageIcon = (language) => {
  switch (language) {
    case LANGUAGES.ENGLISH: {
      return EnglishFlagIcon;
    }

    case LANGUAGES.SPANISH: {
      return SpanishFlagIcon;
    }
  }
};
export const MENU_ITEMS_LABEL = {
  VIEW_CONFIGURATIONS: "View Configurations",
  DUPLICATE: "Duplicate",
  CONFIGURE: "Configure",
  EDIT: "Edit name",
  COLLECTION_EDIT: "Rename",
  ENABLE: "Enable",
  DISABLE: "Disable",
  COLLECTION_DELETE: "Delete"
};

export const DIALOG_TYPES = {
  add: "add",
  rename: "rename",
  delete: "delete",
  enable: "enable",
  disable: "disable"
};

export const VALIDATION_TYPES = {
  MISSING_MANDATORY_CONFIGURATION: "MISSING_MANDATORY_CONFIGURATION",
  BAD_CONFIGURATION: "BAD_CONFIGURATION",
  UNASSIGNED: "UNUSED_CONFIGURATION"
};

export const STATUS_TYPES = {
  DRAFT: "Draft",
  PENDING: "Pending",
  LIVE: "Live",
  DISABLED: "Disabled",
  INCOMPLETE: "Incomplete",
  INVALID: "Invalid",
  INVALID_FIELDS: "Invalid Fields",
  UNASSIGNED: "Unassigned",
  DUPLICATE: "Duplicated",
  READ_ONLY: "Read Only",
  CUSTOM: "Custom"
};

export const STATUS_ORDER = [
  STATUS_TYPES.LIVE,
  STATUS_TYPES.DRAFT,
  STATUS_TYPES.PENDING,
  STATUS_TYPES.UNASSIGNED,
  STATUS_TYPES.INVALID,
  STATUS_TYPES.INVALID_FIELDS,
  STATUS_TYPES.DUPLICATE,
  STATUS_TYPES.INCOMPLETE,
  STATUS_TYPES.DISABLED,
  STATUS_TYPES.READ_ONLY
];

export const STATUS_COLORS = {
  [STATUS_TYPES.DRAFT]: "#5C65E6",
  [STATUS_TYPES.PENDING]: "#5C65E6",
  [STATUS_TYPES.LIVE]: theme.palette.grey[500]
};

export const STATUS_TO_CHIP_COLOR = {
  BACKGROUND: {
    [STATUS_TYPES.DRAFT]: "#FFF2CA",
    [STATUS_TYPES.INCOMPLETE]: "#F9EEEF",
    [STATUS_TYPES.INVALID]: "#F9EEEF",
    [STATUS_TYPES.INVALID_FIELDS]: "#F9EEEF",
    [STATUS_TYPES.UNASSIGNED]: "#FFF2CA",
    [STATUS_TYPES.DUPLICATE]: "#F9EEEF",
    [STATUS_TYPES.LIVE]: "#DDF8EF",
    [STATUS_TYPES.PENDING]: "#EDF5FF",
    [STATUS_TYPES.DISABLED]: theme.palette.grey[200],
    [STATUS_TYPES.READ_ONLY]: theme.palette.grey[200],
    [STATUS_TYPES.CUSTOM]: theme.palette.tertiary[300]
  },
  TEXT: {
    [STATUS_TYPES.DRAFT]: "#B08310",
    [STATUS_TYPES.INCOMPLETE]: "#C13842",
    [STATUS_TYPES.INVALID]: "#C13842",
    [STATUS_TYPES.INVALID_FIELDS]: "#C13842",
    [STATUS_TYPES.UNASSIGNED]: "#B08310",
    [STATUS_TYPES.DUPLICATE]: "#C13842",
    [STATUS_TYPES.LIVE]: "#428E6E",
    [STATUS_TYPES.PENDING]: "#41689E",
    [STATUS_TYPES.DISABLED]: "#2D2C44B2",
    [STATUS_TYPES.READ_ONLY]: "#2D2C44B2",
    [STATUS_TYPES.CUSTOM]: theme.palette.primary[500]
  }
};

export const STATUS_VARIANTS = {
  TEXT: "text",
  FILLED: "filled",
  FILLED_SMALL: "filled small"
};

export const STATUS = "Status";
export const DEFAULT_TEXT_FIELD_ERROR = "Please provide a value";
export const NO_OPTIONS_MESSAGE = "No options available. Create a $label to fill the list.";
export const VAGUE_NO_OPTIONS_MESSAGE = "No options available.";
export const NO_OPTIONS_ERROR_MESSAGE = "Error retrieving $label. Please Refresh the page.";
export const READ_ONLY_TABLE_COLUMN_TOOLTIP = "This column is read-only and cannot be edited.";

export const STATICS_SKILLS_KEYS = [collectionNames.SKILL.VOICE_ESSENTIALS, collectionNames.SKILL.WEB_ESSENTIALS, collectionNames.SKILL.VOICE_OUTBOUND_ESSENTIALS, collectionNames.SKILL.IT_HELP_DESK, collectionNames.SKILL.ITSD_VOICE_ESSENTIALS, collectionNames.SKILL.SMS_OUTBOUND_ESSENTIALS];

export const getMandatoryMessageForType = (type, language) => {
  if (type === FIELD_TYPES.CHOOSE_ONE || type === FIELD_TYPES.CHOOSE_AT_LEAST_ONE || type === FIELD_TYPES.COLLECTION_REF)
    return "This field is mandatory. Please select an option from the list.";
  if (type === FIELD_TYPES.MULTI_LANGUAGE_TEXT)
    return { [language]: "This field is mandatory. Please enter a value for this field." };
  if (type === FIELD_TYPES.FILE)
    return "This field is mandatory. Please upload a file.";
  return "This field is mandatory. Please enter a value for this field.";
};

export const TABS = {
  titles: {
    general: "General Configurations",
    utterances: "Utterances"
  },
  names: {
    general: "General",
    utterances: "Utterances",
    policies: "Policies",
    decisionTrees: "Decision Trees",
    explore: "Explore",
    schema: "Schema"
  }
};

export const AUTO_SAVE_TABS = [TABS.names.explore];
export const WRAPPER_OBJECT_NAME = "OBJECT";
export const LIST_TYPES = {
  TABLE: "OBJECT"
};

export const SKILL_TABLE = {
  EDIT: "Edit",
  DUPLICATE: "Duplicate",
  DELETE: "Delete",
  NO_RESULTS: "Nothing here yet",
  DOWNLOAD: "Download",
  REPLACE: "Replace"
};

export const COLLECTIONS_TYPE_TO_GET_OPTIONS = [INTEGRATIONS];

export const PROD_INTEGRATION_KEY = "bbd6ac84-2e72-4016-9b08-5a23e8c1f80c";

export const VALIDATIONS_SEVERITY = {
  ERROR: "ERROR",
  WARNING: "WARNING"
};

export const SETTINGS_CONFIG = {
  VOICE: {
    "key": "voice_channel_settings",
    "display_key": "Voice Settings",
    "spec_key": "channel-settings", // determines the url we navigate to
    "description": "Telephony channel settings",
    "spec": {
      "display_key": "Voice Settings"
    }
  },
  CHAT: {
    "key": "chat_channel_settings",
    "display_key": "Chat Settings",
    "spec_key": "channel-settings", // determines the url we navigate to
    "description": "Chat widget appearance settings",
    "spec": {
      "display_key": "Chat Settings"
    }
  },
  SMS: {
    "key": "sms_channel_settings",
    "display_key": "SMS Settings",
    "spec_key": "channel-settings",
    "description": "SMS channel settings",
    "spec": {
      "display_key": "SMS Settings"
    }
  }
};

export const STATUS_TO_TEXT = {
  [STATUS_TYPES.DRAFT]: "Draft",
  [STATUS_TYPES.PENDING]: "Pending",
  [STATUS_TYPES.LIVE]: "Live",
  [STATUS_TYPES.DISABLED]: "Disabled",
  [STATUS_TYPES.INCOMPLETE]: "Incomplete",
  [STATUS_TYPES.INVALID]: "Invalid",
  [STATUS_TYPES.DUPLICATE]: "Duplicated"
};
